import { Button, DataTable } from 'shared/components/ui';
import React from 'react';
import './TablaFacturasOS.css';

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
               'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

const formatMontoArgentino = (monto) => {
  const valor = Number(monto) || 0;
  return `$${valor.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const formatPeriodo = (mes, anio) => {
  const nombreMes = MESES[mes - 1] || '';
  return `${nombreMes} ${anio}`;
};

const TablaFacturasOS = ({ facturas = [], onAdjuntar, onVerConstancia, loading = false }) => {
  if (loading) {
    return null;
  }

  if (!facturas.length) {
    return (
      <div className="tabla-facturas-empty" role="status" aria-live="polite">
        <p>No se encontraron facturas</p>
      </div>
    );
  }

  // Ordenar descendente por período (año, luego mes)
  const facturasOrdenadas = [...facturas].sort((a, b) => {
    if (b.anio !== a.anio) return b.anio - a.anio;
    return b.mes - a.mes;
  });

  return (
    <div className="cont-tabla-wrap" role="region" aria-label="Tabla de facturas de obras sociales">
      <DataTable className="cont-tabla tabla-facturas-os">
        <thead>
          <tr>
            <th scope="col">Nro. Factura</th>
            <th scope="col">Obra Social</th>
            <th scope="col">Entidad Facturación</th>
            <th scope="col">Período</th>
            <th scope="col" className="cont-td-num">Monto</th>
            <th scope="col">Estado</th>
            <th scope="col">Tipo Constancia</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {facturasOrdenadas.map((factura) => (
            <tr key={factura.id}>
              <td>{factura.nroFactura}</td>
              <td>{factura.obraSocial}</td>
              <td>{factura.entidadFacturacion}</td>
              <td>{formatPeriodo(factura.mes, factura.anio)}</td>
              <td className="cont-td-num">{formatMontoArgentino(factura.monto)}</td>
              <td>
                <span className={`tabla-facturas-estado ${factura.estadoPago === 'ABONADA' ? 'tabla-facturas-estado-abonada' : 'tabla-facturas-estado-impaga'}`}>
                  {factura.estadoPago}
                </span>
              </td>
              <td>{factura.tipoConstancia || '-'}</td>
              <td>
                {factura.estadoPago === 'IMPAGA' && (
                  <Button
                    className="tabla-facturas-btn tabla-facturas-btn-adjuntar"
                    onClick={() => onAdjuntar?.(factura)}
                    aria-label={`Adjuntar constancia para factura ${factura.nroFactura}`}
                  >
                    Adjuntar constancia
                  </Button>
                )}
                {factura.estadoPago === 'ABONADA' && (
                  <Button
                    className="tabla-facturas-btn tabla-facturas-btn-ver"
                    onClick={() => onVerConstancia?.(factura)}
                    aria-label={`Ver constancia de factura ${factura.nroFactura}`}
                  >
                    Ver constancia
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </DataTable>
    </div>
  );
};

export default TablaFacturasOS;
